
fx.ns("shared.stage", class Area extends fx.Component {

    constructor(data, model, parentContainer, side, preview) {
        super(data);

        this._model = model;
        this._creation = model.creation;
        this._parentContainer = parentContainer;
        this._actionsEnabled = true;
        this._dragActive = false;
        this._rawDisplay = false;

        this.displayedSide = side;
        this.preview = preview;

        this.listenUpdates(this.model, true);
    }

    /***************** Getters / Setters *****************/

    get rawDisplay() {
        return this._rawDisplay;
    }

    set rawDisplay(val) {
        this._rawDisplay = val;
    }

    // displayed part of BookArea. Used to display front cover / back cover only.
    get displayedSide() {
        return this._displayedSide;
    }

    set displayedSide(val) {
        if (this._displayedSide)
            this.removeClass(this._displayedSide);

        this._displayedSide = val;

        if (this._displayedSide)
            this.addClass(this._displayedSide);
    }

    get loaded() {
        return this.stage && this.stage.loaded;
    }

    /*get loadedFirst()
    {
        return this._loadedFirst;
    }*/

    get single() {
        return !!this._displayedSide;
    }


    get scale() {
        return this._scale;
    }

    set scale(val) {
        this._scale = val;

        this.attr("scale", val);
    }

    get model() {
        return this._model;
    }

    set model(val) {
        this._model = val;
        this._creation = model.creation;
    }

    get element() {
        return this.data;
    }

    set element(val) {
        this.data = val;

        if (this.initialized)
            //this.load(this.element, this.displayedSide);
            this.load();
    }

    get creation() {
        return this._creation;
    }

    set creation(val) {
        this._creation = val;
    }

    get parentContainer() {
        return this._parentContainer;
    }

    get active() {
        return this._active;
    }

    set active(val) {
        this._active = val;

        if (val)
            this.addClass("active");
        else
            this.removeClass("active");
    }

    get pageWidth() {
        return this.element.width;
    }

    get pageHeight() {
        return this.element.height;
    }

    /***************** Actions *****************/


    onReady() {
        super.onReady();
        this.on("component-added", this.onComponentAdded, this.stage);
    }

    create() {
        super.create();

        this.stageContainer = new fx.components.Box("stage-container");

        this.stage = new shared.stage.Stage(this.element, this.model, this._parentContainer.componentFactory, this.displayedSide, this.preview);

        this.stageContainer.addChild(this.stage, { top: 0, left: 0, height: this.height(), width: this.width() });

        this.addChild(this.stageContainer, { top: 0, left: 0, height: this.height(), width: this.width() });

        if (this.element)
            this.attr("data-id", this.element.id);
    }

    refresh() {
        this.stage.updateScale();
    }

    // disable native positionning
    position() { }

    addComponent(data) {
        this.element.addComponent(data, "", this.creation.pageWidth, this.creation.pageHeight);
    }

    applyBackground(background) {
        this.data.applyBackground(background);
    }

    removeAllComponents() {
        this.element.removeAllComponents();
        this.element.removeAllComponents();
    }

    load() {
        if (this.loaded && this.element == this.stage.data) return false;

        if (!this.loadMedia()) {
            this.stage.load(this.data, this.displayedSide);
            this.addClass("loaded");

            return true;
        }

        return false;
    }

    unload() {
        if (!this.loaded || this.dragActive) return;

        this.stage.unload();
        this.removeClass("loaded");
    }

    getElement(id) {
        return this.stage ? this.stage.getChild(id) : null;
    }

    getChildFromData(data) {
        return this.stage ? this.stage.getChildFromData(data) : null;
    }

    setBackground(color) {
        this.element.updateBackgroundColor(color, true);
    }

    viewport(val, applyOnly) {
        super.viewport(val, applyOnly);

        if (this.stage) {
            this.stageContainer.viewport(val, applyOnly);
            this.stage.viewport(val, applyOnly);
        }
    }

    applyLayout(layout, side) {
        this._applyLayout(layout, false, side);
    }


    applyLayoutAll(layout) {
        this._applyLayout(layout, true);
    }

    _applyLayout(layout, all, side) {
        if (!this.model) return;

        if (all || side)
            this.activeSide = side ? side : "";


        let toLoad = this.loadMedia(layout);

        //let mediasToLoad = this.getMediasToLoad(layout);

        if (!toLoad) {
            let pageWidth = layout.doublepage ? this.pageWidth : this.creation.pageWidth;
            let pageHeight = this.pageHeight;

            if (all)
                this.creation.applyLayout(layout);
            else
                this.element.applyLayout(layout, pageWidth, pageHeight, this.extraWidth, this.activeSide);
        }
        else {
            this._layoutToApply = { all: all, layout: layout, side: this.activeSide };
            //this.model.loadLayoutMedias( mediasToLoad );
            //this.loading(true, fx.text("Chargement"), "light");
        }
    }

    addPhoto(data) {
        let element;
        // check if no photo on screen apply default layout with on photo and set photo
        if (this.data.photosComponents.length == 0) {
            let layout = this.model.layouts.getDefaultLayout();

            this.data.applyLayout(layout, this.pageWidth, this.pageHeight);
        }

        // check if empty photos on double page from the left to the right

        // forst from left to right, top to bottom
        let components = this.data.photosComponents.sort(function (a, b) {
            let centerA = { x: a.x + a.width / 2, y: a.y + a.height / 2 };
            let centerB = { x: b.x + b.width / 2, y: b.y + b.height / 2 };
            return (centerA.y != centerB.y) ? centerA.y - centerB.y : centerA.x - centerB.x;
        });
        let notempty = components.filter((component) => component.content);

        // if all photo are filled, let's set an index, and change content of each picture
        if (notempty.length == components.length) {
            if (this._photoIndex === undefined || this._photoIndex >= components.length)
                this._photoIndex = 0;

            element = components.getItemAt(this._photoIndex);

            this._photoIndex++;
        }
        else {
            for (let i = 0; i < components.length; i++) {
                let component = components.getItemAt(i);
                if (!component.content) {
                    element = component
                    break;
                }
            }
        }

        if (element) {
            element.content = data.content;

            let components = this.stage.getChilds();
            for (let j = 0; j < components.length; j++) {
                let component = components.getItemAt(j);
                if (component.data.id == element.id) {
                    return component;
                }
            }

        }
    }

    initLayoutData() {
        this._layoutData = {
            left: { code: "", position: 0 },
            right: { code: "", position: 0 }
        };

    }

    getMediasToLoad(layout) {
        // check all stickers and backgrounds
        // and load them if not existing
        let stickers = layout.getStickers();
        let backgrounds = layout.getBackgrounds();

        let mediasToLoad = [];

        for (let i = 0; i < stickers.length; i++) {
            if (parseInt(stickers[i].content)) {
                if (layout instanceof models.CreationElement && this.model.stickers.notExisting(stickers[i].content))
                    layout.removeSticker(stickers[i].content);
                else
                    if (!this.model.stickers.find({ id: stickers[i].content }) && !mediasToLoad.find({ id: stickers[i].content, type: "sticker" }))
                        mediasToLoad.push({ type: "sticker", id: stickers[i].content });
            }
        }

        // TODO : Cause issue with infinite area loading. To fix later.

        for (let i = 0; i < backgrounds.length; i++) {
            if (parseInt(backgrounds[i].content)) {
                if (layout instanceof models.CreationElement && this.model.backgrounds.notExisting(backgrounds[i].content))
                    layout.removeBackground(backgrounds[i].content);
                else
                    if (!this.model.backgrounds.find({ id: backgrounds[i].content }) && !mediasToLoad.find({ id: backgrounds[i].content, type: "background" }))
                        mediasToLoad.push({ type: "background", id: backgrounds[i].content });
            }
        }

        return mediasToLoad;
    }


    loadMedia(layout) 
    {
        if (this.loadingMedia)
            return;

        let mediasToLoad = this.getMediasToLoad(layout || this.data);

        if (mediasToLoad.length == 0)
            return false;
        else {
            this.model.loadLayoutMedias(mediasToLoad);
            this.loading(true, fx.text("Chargement"), "light");
            this.loadingMedia = true;
            return true;
        }
    }


    _layoutMediasLoaded() 
    {
        this.loading(false);
        this.loadingMedia = false;

        if (this._layoutToApply) 
        {
            if (this._layoutToApply.all)
                this.creation.applyLayout(this._layoutToApply.layout);
            else
                this.element.applyLayout(this._layoutToApply.layout, this.creation.pageWidth, this.pageHeight, this.extraWidth, this._layoutToApply.side);

            this._layoutToApply = null;
        }
        else
            this.load();
    }

    /***************** Events *****************/

    // When a Text is added manually, we need to display Frame and ToolBar
    onComponentAdded(event) {
        if (!event.detail.component)
            return;

        if (event.detail.component.data.isText && (event.detail.component.data.creation == "manual" || event.detail.component.data.creation == "dropped"))
            this.trigger("select", { area: this, element: event.detail.component });

        //this.updateCode();
    }

    onDataUpdated(action) {
        super.onDataUpdated(action);

        if (action.impacts("id") && action.model instanceof models.CreationElement)
            this.attr("data-id", this.element.id);

        //this.updateCode();
    }

    onChildUpdated(action) {
        /*if (action.model instanceof models.CreationElementContent)
            this.updateCode(); */

        if (action.tag != "fill" && action.impacts("x", "y", "width", "height", "width_inner", "height_inner") && action.model instanceof models.CreationElementContent)
            this._photoIndex = undefined;
    }

    onDataEvent(event) {
        super.onDataEvent(event);

        switch (event.type) {
            case "fonts-loaded":
                //this.updateCode();
                event.stopPropagation();
                break;

            case "media-loaded":
                //this.updateCode();
                break;

            case "layout-medias-loaded":
                this._layoutMediasLoaded();
                break;

            case "load-layout-medias-error":
                this.loading(false);
                break;

            case "drag-over":
                this._photoIndex = undefined;
                break;
        }

    }

    onDisplayUpdated() {
        super.onDisplayUpdated();

        if (this.stage)
            this.stage.scale = this.scale;
    }


    /*updateCode()
    {
        if (fx.get("app") != "config")
            return;
    
        // everytime a page is updated, we update SVG
        //this.delay(this._updateCode, 250);
    }*/

    /*_updateCode()
    {
        if (this.data && this.stage.loaded)
            this.data.prop("code", (this.displayedSide == "right" && this.data.isCover ? "<style>.Stage { left : 0px!important;}</style>" : "") + this.stage.contentHTML);
    }*/

    selectActivePart() {
        if (!this.stage || !this.stage.node) return;

        this.active = true;
    }


});